import React from "react";
import axios from "axios";
import Costanti from "../../constantiX";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Checkbox } from "primereact/checkbox";
import { Column, InputText, Dialog, FileUpload, Toast, RadioButton } from "primereact";
import { Formik } from "formik";
import MultiLanguageEditor from "../MultiLanguageEditor";
import * as Yup from "yup";

import "../../assets/css/badge.css";
import { getMultiLngInitValue, validateMultiLanguageEditor } from "../../util";

class ListaAllergeni extends React.Component {
  constructor() {
    super();
    this.actions = [
      {
        id: 1,
        icon: "pi-search",
        label: "",
        action: (id) => {
          this.vai(id, "V");
          console.log("View " + id);
        },
      },
    ];
    this.state = {
      activePage: 0,
      lista: [],
      totalRecords: 0,
      first: 0,
      rows: 10,
      loading: true,
      visible1: false,
      languages: "",
    };

    this.token = sessionStorage.getItem("ICEtoken");
    this.utente = JSON.parse(sessionStorage.getItem("utente"));
    this.state = {
      xcarica: "sezione",
      allergeni: [],
      activePage: 1,
      totalRecords: 0,
      pageSize: 10,
      first: 0,
      visible2: false,
      visible3: false,
      singolo: {},
    };
    this.onPage = this.onPage.bind(this);
    this.prodottoid = 0;
  }

  showMessage(tipo, messageError, dettaglio) {
    var icona = "";
    if (tipo == "error") {
      icona = "pi pi-times-circle";
    }
    if (tipo == "info") {
      icona = "pipi-info-circle";
    }
    if (tipo == "success") {
      icona = "pi pi-check-circle";
    }
    if (tipo == "warning") {
      icona = "pi pi-exclamation-triangle";
    }
    this.toastBC.show({
      severity: tipo,
      life: 3000,
      closable: false,
      content: (
        <div className="flex flex-column" style={{ flex: "1" }}>
          <div className="text-center">
            <i className={icona} style={{ fontSize: "3rem" }}></i>
            <h4>{messageError}</h4>
            <h5>{dettaglio}</h5>
          </div>
        </div>
      ),
    });
  }

  componentDidMount() {
    this.prodottoid = this.props.prodottoid;
    this.caricaDati(1, this.state.pageSize);
    this.stato = this.props.stato;
    if (this.stato == "U") {
      this.actions.push(
        {
          id: 2,
          icon: "pi-pencil",
          label: "",
          action: (id) => {
            this.vai(id, "U");
            console.log("Update " + id);
          },
        },
        {
          id: 3,
          icon: "pi-trash",
          label: "",
          action: (id) => {
            this.vai(id, "D");
            console.log("Delete " + id);
          },
        },
      );
    }
  }

  async caricaDati(pagina, numrec) {
    try {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      this.setState({ loading: true });
      var quer = "page=" + pagina + "&num=" + numrec + "&prodottoid=" + this.prodottoid;
      const res = await axios.get(Costanti.UrlCallApi + "allergeni/all?" + quer, config);
      res.data.lista1.forEach((element) => {
        element.azioni = this.actions;
      });
      this.setState({ allergeni: res.data.lista1, totalRecords: res.data.conta1, loading: false });

      const { data } = await axios.get(Costanti.UrlCallApi + "azienda/lingue/" + this.utente.aziendaid, config);
      this.setState({ languages: data, loading: false });
    } catch (error) {
      alert(error);
    }
  }

  caricaSingolo(id) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ loading: true });
    axios
      .get(Costanti.UrlCallApi + "allergeni/" + id, config)
      .then((res) => {
        this.setState({ singolo: res.data, loading: false });
        //alert(JSON.stringify(this.state.prodotti))
      })
      .catch((error) => {
        alert(error);
      });
  }

  salva(values) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    this.setState({ isSubmitting: true });

    if (this.state.tipo == "D") {
      values.status = "E";
      axios
        .post(Costanti.UrlCallApi + "allergeni/salva/" + this.state.singolo.id, values, config)
        .then((res) => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }
    if (this.state.tipo == "U") {
      axios
        .post(Costanti.UrlCallApi + "allergeni/salva/" + this.state.singolo.id, values, config)
        .then((res) => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }
    if (this.state.tipo == "A") {
      var dato = {
        datains: null,
        dataupd: null,
        id: 0,
        nome: values.nome,
        descrizione: values.descrizione,
        nomeen: values.nomeen,
        descrizioneen: values.descrizioneen,
        prodottoid: this.prodottoid,
        uteins: 1,
        uteupd: null,
        valore: values.valore,
        tipo: values.tipo,
        status: " ",
        traduzione: values.traduzione,
      };
      axios
        .post(Costanti.UrlCallApi + "allergeni/aggiungi", dato, config)
        .then((res) => {
          this.showMessage("success", "Dati salvati correttamente", "");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.showMessage("error", "Errore nel salvataggio", error.message);
          this.setState({ isSubmitting: false });
        });
    }

    setTimeout(() => this.setVisible1(false), 1000);
  }

  setVisible1(val) {
    this.setState({ visible1: val });
    this.caricaDati(this.state.activePage, this.state.pageSize);
  }

  vai(id, tipo) {
    this.caricaSingolo(id);
    this.setVisible1(true);
    this.setState({ tipo: tipo });
    switch (tipo) {
      case "A":
        this.setState({ editMode: true, singolo: {}, intestazione: "Aggiungi Allergene" });
        break;
      case "V":
        this.setState({ intestazione: "Visualizza Allergene" });
        break;
      case "D":
        this.setState({ intestazione: "Elimina Allergene" });
        break;
      case "U":
        this.setState({ editMode: true, intestazione: "Modifica Allergene" });
        break;
    }
  }
  onPage(event) {
    this.setState({
      loading: true,
      activePage: event.page + 1,
      first: event.first,
    });
    this.caricaDati(event.page + 1, this.state.pageSize);
  }

  setPDF(value) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.token,
      },
    };
    axios
      .get(Costanti.UrlCallApi + "stampe/allergeni/" + this.prodottoid, config)
      .then((res) => {
        const link = document.createElement("a");
        const url = Costanti.UrlCallApi + "file/getFile/" + res.data;

        link.href = url;
        link.setAttribute("download", res.data);
        // Append to html link element page
        document.body.appendChild(link);
        // Start download
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        this.showMessage("error", "Errore nella stampa", error.message);
        this.setState({ isSubmitting: false });
      });
  }


  getMultiLngInfo(id) {
    let nome = "";
    let descrizione = "";
    this.state.allergeni.forEach((element) => {
      if (element.id == id) {
        const traduzione = element.traduzione;

        const descrizioneObj =
          traduzione.length > 0 && traduzione.find((el) => el.nomecampo === "descrizione" && el.lingua === "it");

        const nomeObj = traduzione.length > 0 && traduzione.find((el) => el.nomecampo === "nome" && el.lingua === "it");

        descrizione = descrizioneObj ? descrizioneObj.testo : "";
        nome = nomeObj ? nomeObj.testo : "";
      }
    });
    return { nome, descrizione };
  }

  // Function that returns a Yup schema with the custom validation
  multiLanguageEditor = (languages) => {
    return Yup.array()
      .required("Campo richiesto per tutte le lingue")
      .test({
        name: "multiLanguageEditor",
        message: "Campo richiesto per tutte le lingue",
        test: (value) => validateMultiLanguageEditor(value, languages) === undefined,
      });
  };

  validationSchema(languages) {
    return Yup.object().shape({
      nome: this.multiLanguageEditor(languages),
      descrizione: this.multiLanguageEditor(languages),
    });
  }

  render() {
    return (
      <div>
        <Toast ref={(el) => (this.toastBC = el)} position="bottom-center" />

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>

        <Dialog
          header="PDF"
          closable={false}
          visible={this.state.viewPDF}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <footer>
            <div className="border-top-1 surface-border pt-3">
              <Button type="button" icon="pi pi-check" onClick={() => this.setPDF(false)} label="Chiudi" />
            </div>
          </footer>
        </Dialog>

        <DataTable
          emptyMessage={<div className="flex w-full justify-content-center font-bold ">NO DATA FOUND</div>}
          value={this.state.allergeni}
          rows={this.state.pageSize}
          totalRecords={this.state.totalRecords}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="	(pag. {currentPage} di {totalPages}) "
          paginator={true}
          onPage={this.onPage}
          loading={this.state.loading}
          lazy={true}
          first={this.state.first}
          header={
            <div className="mb-1 flex align-items-center justify-content-between">
              <span className="text-xl font-medium text-900">Lista Allergeni</span>
              <InputText type="search" className="border-none" placeholder="Cerca..." />
          
              {/*<Button label="Esporta in Pdf" onClick={()=>this.setPDF(true)}   icon="pi pi-file-pdf" className="p-button-rounded p-button-danger "/> */}
              {this.prodottoid > 0 && (
                <Button
                  label="Aggiungi"
                  onClick={() => this.vai(0, "A")}
                  icon="pi pi-plus"
                  className="p-button-rounded p-button-primary "
                />
              )}
            </div>
          }
          responsiveLayout="stack"
        >
          <Column id="id1" field="nome" header="Nome" body={(item) => this.getMultiLngInfo(item.id).nome} />
          <Column
            id="id1"
            field="descrizione"
            header="Descrizione"
            body={(item) => this.getMultiLngInfo(item.id).descrizione}
          />
          <Column
            field="prodotto"
            header="Prodotto"
            body={(item) => <Checkbox disabled checked={item.tipo === 1} className="mr-4" />}
          ></Column>
          <Column
            field="magazzino"
            header="Magazzino"
            body={(item) => <Checkbox disabled checked={item.tipo === 2} className="mr-4" />}
          ></Column>
          <Column
            field="contaminazione"
            header="Rischio Contaminazione"
            body={(item) => <Checkbox disabled checked={item.tipo === 3} className="mr-4" />}
          ></Column>

          <Column
            id="id5"
            field="id"
            header="Azioni"
            body={(item) => (
              <div className="product-list-action flex" style={{ alignItems: "center", gap: "1rem" }}>
                {this.actions.map((action) => (
                  <Button
                    key={action.id}
                    className="p-button-sm"
                    icon={`pi ${action.icon}`}
                    label={action.label}
                    aria-label={action.label}
                    onClick={(e) => {
                      e.stopPropagation();
                      action.action(item.id);
                    }}
                  />
                ))}
              </div>
            )}
          ></Column>
        </DataTable>

        <Dialog
          header={this.state.intestazione}
          closable={false}
          visible={this.state.visible1}
          modal
          breakpoints={{ "960px": "75vw", "640px": "100vw" }}
          style={{ width: "40vw" }}
          draggable={false}
          resizable={false}
        >
          <div className="border-top-1 surface-border pt-4 col-12">
            <div className="surface-card p-2  border-round">
              <Formik
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{
                  nome: this.state.singolo.traduzione,
                  descrizione: this.state.singolo.traduzione,
                  tipo: this.state.singolo.tipo,
                  status: this.state.singolo.status,
                }}
                enableReinitialize
                validationSchema={() => this.validationSchema(this.state.languages)}
                onSubmit={(values) => {
                  const { nome, descrizione, ...rest } = values;
                  const formData = { ...rest, traduzione: [...nome, ...descrizione] };
                  this.salva(formData);
                }}
              >
                {({ values, errors, handleSubmit, setFieldValue, isSubmitting }) => {
                  return (
                    <form onSubmit={handleSubmit}>
                      <div className="grid formgrid p-fluid">
                        <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

                        <div className="field mb-1 col-12 md:col-12">
                          <MultiLanguageEditor
                            label={"Nome"}
                            languages={this.state.languages}
                            content={getMultiLngInitValue("allergeni", "nome", this.state.languages, values["nome"])}
                            isReadOnly={this.state.tipo === "V" || this.state.tipo === "D"}
                            fieldName={"nome"}
                            setValue={setFieldValue}
                            isAddItem={this.state.tipo === "A"}
                            error={errors.nome}
                          />
                        </div>

                        <div className="flex field mb-1 col-12 md:col-12">
                          <MultiLanguageEditor
                            label={"Descrizione"}
                            type="text-area"
                            languages={this.state.languages}
                            content={getMultiLngInitValue(
                              "allergeni",
                              "descrizione",
                              this.state.languages,
                              values["descrizione"],
                            )}
                            isReadOnly={this.state.tipo === "V" || this.state.tipo === "D"}
                            fieldName={"descrizione"}
                            setValue={setFieldValue}
                            isAddItem={this.state.tipo === "A"}
                            error={errors.descrizione}
                          />
                        </div>

                        <div className="flex flex-row gap-1 field mb-1 col-12 md:col-12">
                          <RadioButton
                            name="tipo"
                            readOnly={!this.state.editMode}
                            value="1"
                            checked={values.tipo === 1}
                            onChange={() => setFieldValue("tipo", 1)}
                          />
                          <label htmlFor="descrizione" className="mt-1 font-medium text-600">
                            Prodotto
                          </label>
                        </div>
                        <div className="flex flex-row gap-1 field mb-1 col-12 md:col-12">
                          <RadioButton
                            name="tipo"
                            readOnly={!this.state.editMode}
                            value="2"
                            checked={values.tipo === 2}
                            onChange={() => setFieldValue("tipo", 2)}
                          />
                          <label htmlFor="descrizione" className="mt-1 font-medium text-600">
                            Magazzino
                          </label>
                        </div>
                        <div className="flex flex-row gap-1 field mb-1 col-12 md:col-12">
                          <RadioButton
                            name="tipo"
                            readOnly={!this.state.editMode}
                            value="3"
                            checked={values.tipo === 3}
                            onChange={() => setFieldValue("tipo", 3)}
                          />
                          <label htmlFor="descrizione" className="mt-1 font-medium text-600">
                            Rischio Contaminazione
                          </label>
                        </div>
                      </div>
                      <footer>
                        <div className="flex flex-row gap-2 border-top-1 surface-border pt-3">
                          <Button
                            type="submit"
                            visible={this.state.tipo == "U"}
                            icon="pi pi-save"
                            label="Salva"
                            disabled={isSubmitting}
                            loading={isSubmitting}
                          />
                          <Button
                            visible={this.state.tipo == "A"}
                            icon="pi pi-save"
                            label="Aggiungi"
                            disabled={isSubmitting}
                            loading={isSubmitting}
                          />
                          <Button
                            type="submit"
                            visible={this.state.tipo == "D"}
                            icon="pi pi-save"
                            label="Elimina"
                            p-button-outlined
                            p-button-danger
                            className="p-button-outlined p-button-danger "
                            disabled={isSubmitting}
                            loading={isSubmitting}
                          />
                          <Button
                            type="button"
                            className="pi p-button-outlined"
                            onClick={() => this.setVisible1(false)}
                            label="Annulla"
                          />
                        </div>
                      </footer>
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default ListaAllergeni;
